import React, {useState,useEffect} from "react"
import { getDatabase, ref, onValue } from "firebase/database"
// import {  getStorage} from "firebase/storage"
import app from "../../api/firebaseConf"
// import moment from "moment"
// import { Chart } from "react-chartjs-2"

export default function ChartNumeric (props){
    // const [dates, setDates] = useState('')
    const [datos, setDatos] = useState(['0.0'])

    useEffect(()=>{
      const db = getDatabase(app);
    //   const storage = getStorage(app)
        
        const starCountRef = ref(db, props.path);
        onValue(starCountRef, async(snapshot) => {
        //const data = snapshot.val();
        //console.log(data)

        // const dataDates = [];
        // const dataSensor = [];
        const array = []
        snapshot.forEach((data) => {
            const dataVal = data.val().reading;
            array.push(String(dataVal))
            //const fecha = moment.unix(dataVal.epoch).format('h:mm:ss');
            //const temperatura = data.val().temp
            //dataDates.push(fecha);
            //sdataTemp.push(data.val().reading)
            
        })
    
        while (array.length >1 )
            {
                array.shift()
            }
       
            setDatos(array)


    });     

    },[])
    return <div className={`flex flex-col items-center justify-center h-full`}>
            <p className="font-press-start font-semibold capitalize text-sm sm:text-xl text-slate-600 py-1">
                {props.label}
            </p>
            <div className="grow flex items-center justify-center pb-3">
                <b className="text-4xl lg:text-6xl font-press-start uppercase">{datos[0].split('.')[0]}</b><p className="font-press-start uppercase font-semibold text-xl sm:text-2xl ">{datos[0].split('.')[1] !== '00' ? '.'+datos[0].split('.')[1]:''} {props.unidad}</p>
            </div>
           
    </div>
}